import ProtocolRepository from "@/repositories/vns/ProtocolRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'protocol',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ProtocolRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.protocol)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ProtocolRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.protocols)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await ProtocolRepository.search(params).then(response => {
                if (response.data.data.protocols.length > 0){
                    const array = response.data.data.protocols
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
